import React, { FC, useState } from 'react';
import { MATERIAL_ICON_VIDEO } from '../../shared/common/Button/Icon';
import VideoPlayerPopup from '../../shared/components/VideoPlayerPopup';
import { Button, ButtonSize, ButtonTheme } from '../../shared/common/Button';
import { useEntryPageQuery } from '../../shop/entrypages/useEntryPageQuery';
import { LoanFormat, parseLoanFormat } from '../../../models/LoanFormat';
import { LoadingWrapper } from '../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../shared/components/LoadingOverlay';
import { BlankCoverProvider } from '../../contexts/blank-cover';
import { EntryPageContainer, EntryPageProductGroups } from '../../shop/entrypages/EntryPage';
import { useLocation, useParams } from 'react-router';
import queryString from 'query-string';
import './LibxFeaturedEntryPage.scss';
import { LOANFORMAT_ALL_OBJECT, loanFormatKeyToObject } from '../../store/loanFormat/actions';
import { useTranslation } from 'react-i18next';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';

export const LibxFeaturedEntryPage: FC = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const { loanFormat: loanFormatParam, shopLanguage } = useParams<{ loanFormat: string; shopLanguage?: string }>();
    const loanFormat = parseLoanFormat(loanFormatParam) ?? LoanFormat.eBooks;
    const loanFormatUrl = loanFormatKeyToObject(loanFormatParam)?.urlKey ?? LOANFORMAT_ALL_OBJECT.urlKey;
    const { value: ageCategory } = useAgeCategorySearchParam();

    const queryParams = queryString.parse(location.search);
    const [showVideo, setShowVideo] = useState(Object.keys(queryParams).includes('intro'));

    const entryPage = useEntryPageQuery('LIBX_FEATURED', { loanFormat, ageCategory, shopLanguage });
    const isLoading = entryPage.status === 'loading';

    const trainingVideo = (
        <VideoPlayerPopup showVideo={showVideo} hideVideo={() => setShowVideo(false)} vimeoId={282263914} />
    );

    return (
        <div className="libx-featured-entry-page">
            {trainingVideo}
            <EntryPageContainer
                pageType="LIBX_FEATURED"
                isLoading={isLoading}
                loanFormatUrl={loanFormatUrl}
                entryPageData={entryPage.data}
                shopLanguage={shopLanguage}
            >
                <div className="intro-button">
                    <Button
                        onClick={() => setShowVideo(true)}
                        text={t('yourLocalContent.localContentCollection.introductionAndTraining')}
                        icon={MATERIAL_ICON_VIDEO}
                        size={ButtonSize.LARGE}
                        theme={ButtonTheme.NEUTRAL}
                    />
                </div>
                {isLoading ? (
                    <LoadingWrapper>
                        <LoadingOverlay loading={true} />
                    </LoadingWrapper>
                ) : (
                    <BlankCoverProvider value={false}>
                        <EntryPageProductGroups
                            productGroups={entryPage.data.productGroups}
                            shopLanguage={shopLanguage}
                        />
                    </BlankCoverProvider>
                )}
            </EntryPageContainer>
        </div>
    );
};
